import { render, staticRenderFns } from "./FaqsTable.vue?vue&type=template&id=d8b58be8"
import script from "./FaqsTable.vue?vue&type=script&lang=js"
export * from "./FaqsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports